<script setup lang="ts">
import type { Iprops } from './UiItem.types'

withDefaults(defineProps<Iprops>(), {
  layout: 'default',
})
</script>

<template>
  <div :class="['ui-item', `ui-item--${layout}`]">
    <div class="ui-item__picture">
      <img
        v-if="item.image"
        class="ui-item__img"
        :src="item.image.url"
        alt="item.image.alternative"
      >
    </div>

    <div class="ui-item__content">
      <h4
        class="ui-item__heading"
        v-html="$t(item.title)"
      />

      <div
        v-if="item.text"
        class="ui-item__text"
        v-html="$t(item.text)"
      />

      <NuxtLink
        v-if="item.link"
        :external="item.link.external || false"
        :target="item.link.external ? '_blank' : '_self'"
        class="ui-item__link"
        :to="$t(item.link.href)"
      >
        {{ $t(item.link.text) }}
      </NuxtLink>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ui-item {
  display: flex;
  flex: 1 0 0;
  gap: 1.6rem;
  $root: &;

  &__picture {
    min-width: 5.6rem;
    width: 5.6rem;
    height: 5.6rem;
  }

  &__content {
    width: auto;
  }

  &__heading {
    padding-bottom: 0.8rem;
    color: $text-400;
    @include h10;
  }

  &__text {
    @include body-2-medium;
    color: $text-400;
  }

  &__link {
    @include body-1-medium;
    display: inline-block;
    margin-top: 1.6rem;
    text-decoration: underline;
    text-decoration-color: $purple-400;
  }

  @include atM {
    gap: 3.2rem;
    margin-bottom: 5.6rem;

    &__heading {
      @include h8;
      padding-bottom: 1.6rem;
    }

    &__text {
      @include body-1-medium;
    }

    &__content {
      width: auto;
    }

    &__picture {
      min-width: 7.2rem;
      width: 7.2rem;
      height: 7.2rem;
    }

    &__img {
      width: 100%;
      height: 100%;
    }
  }

  &--layout-1 {

    align-items: center;
    margin-bottom: 0;

    #{$root}__heading {
      padding-bottom: 0;
      @include body-2-medium;
    }

    @include atXS {
      flex: 0 1 30%;
      justify-content: center;
    }

    @include atM {
      #{$root}__heading {
        @include h10;
      }
    }
  }
}
</style>
